'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SmartPercentageImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _SmartImagePercantage = require('./SmartImage.percantage.styled');

var S = _interopRequireWildcard(_SmartImagePercantage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmartPercentageImage = exports.SmartPercentageImage = function (_React$PureComponent) {
    _inherits(SmartPercentageImage, _React$PureComponent);

    function SmartPercentageImage() {
        _classCallCheck(this, SmartPercentageImage);

        return _possibleConstructorReturn(this, (SmartPercentageImage.__proto__ || Object.getPrototypeOf(SmartPercentageImage)).apply(this, arguments));
    }

    _createClass(SmartPercentageImage, [{
        key: 'render',
        value: function render() {
            var _props$definition = this.props.definition,
                prefix = _props$definition.prefix,
                value = _props$definition.value,
                suffix = _props$definition.suffix;

            return React.createElement(S.Content, null, prefix && React.createElement(S.Prefix, null, prefix), React.createElement(S.Value, null, value), React.createElement(S.SuffixWrapper, null, React.createElement(S.Percentage, null, "%"), suffix && React.createElement(S.Suffix, null, suffix)));
        }
    }]);

    return SmartPercentageImage;
}(React.PureComponent);
//# sourceMappingURL=SmartImage.percentage.js.map